<p-table #dt styleClass="p-datatable-striped" [value]="invoice.lines">
	<ng-template pTemplate="header">
		<tr>
			<th>Qty</th>
			<th>Description</th>
			<th></th>
			<th>Extension</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr>
			<td>
				{{ rec.quantity }}
			</td>
			<td>
				{{ rec.lineDescription }}
			</td>
			<td>
				<span *ngIf="rec.discountValue"> -{{ rec.discountValue | currency }} </span>
			</td>
			<td>
				{{ rec.price | currency }}
			</td>
		</tr>
	</ng-template>
</p-table>
